<template>
  <el-container>
    <div class="view-window">
      <div :class="['mc',{'slide-left':slide == 'left','slide-right':slide == 'right'}]">
        <div id="m" @click="show"></div>
        <div id="d" @click="hide"></div>
      </div>
    </div>
  </el-container>
</template>


<script>
export default {
  data(){
    return {
      slide:''
    }
  },
  methods:{
    show(){
      this.slide = 'left'
    },
    hide(){
      this.slide = 'right'
    }
  }
}
</script>


<style>

.view-window{
  flex: 1;
  position: relative;
}

.mc{
  width: 200%;
  position: absolute;
  left: 0;
  height: 100%;
}

#m{
  width: 50%;
  background: #ccc;
  flex: 1;
  height: 100%;
  display: inline-block;
  
}

#d{
  width: 50%;
  background: #123;
  flex: 1;
  height: 100%;
  display: inline-block;
}

.slide-left{
  animation: slide-left 500ms forwards;
}

.slide-right{
  animation: slide-right 500ms forwards;
}

@keyframes slide-left {
  from {left: 0}
  to {left: -100%}
}

@keyframes slide-right {
  from {left: -100%}
  to {left: 0}
}
</style>

